import { atom } from "recoil";
import { IOfficeAppliancesBrand } from "../type";

const PREFIX = "officeAppliancesBrand";

export const brandAddState = atom<boolean>({
  key: `${PREFIX}/addState`,
  default: false,
});

export const brandEditState = atom<boolean>({
  key: `${PREFIX}/editState`,
  default: false,
});

export const brandRowForEdit = atom<IOfficeAppliancesBrand | null>({
  key: `${PREFIX}/rowForEdit`,
  default: null,
});

export const brandFilterText = atom<string>({
  key: `${PREFIX}/filterText`,
  default: "",
});

export const brandSelectedRows = atom<IOfficeAppliancesBrand[]>({
  key: `${PREFIX}/selectedRows`,
  default: [],
});

export const brandFetching = atom<boolean>({
  key: `${PREFIX}/isFetching`,
  default: true,
});

export const brandSaving = atom<boolean>({
  key: `${PREFIX}/isSaving`,
  default: false,
});
